import { TableActions } from "../thunks/table.thunk";

interface TableSliceProps {
  data: any;
  initiateBulkCallAfterUpload?: boolean;
}

const initialState: TableSliceProps = {
  data: {},
};

export default function tableInfoReducer(state = initialState, action: any) {
  switch (action.type) {
    case TableActions.SET_STATE:
      var { entity, entityData } = action.payload;
      state = {
        data: {
          ...state.data,
          [entity]: {
            ...state.data?.[entity],
            ...entityData,
          },
        },
      };
      return state;

    case TableActions.UPDATE_SORT_CONFIG:
      entity = action.payload.entity;
      state = {
        ...state,
        data: {
          ...state.data,
          [entity]: {
            ...state.data?.[entity],
            sort_by: action.payload.sort_by,
          },
        },
      };

      return state;

    case TableActions.RESET_STATE:
      entity = action.payload.entity;
      state = {
        ...state,
        data: {
          ...state.data,
          [entity]: {
            ...state?.data?.[entity],
            ...action.payload.entityData,
          },
        },
      };
      return state;

    case TableActions.UPDATE_SHOW_RECENT:
      entity = action.payload.entity;
      const showRecent = action.payload.showRecent;
      state = {
        ...state,
        data: {
          ...state.data,
          showRecent: showRecent,
        },
      };
      return state;

    default:
      return state;
  }
}
